import React, {Component} from 'react'
import Link from 'gatsby-link'
import Menu from '../components/Menu.js'
import LngSwitcher from '../components/LngSwitcher.js'
import symbol from '../images/symbol.svg'
import logo from '../images/logo.png'
import humberger from '../images/humberger.svg'

export default class Header extends Component {
  constructor () {
    super()
    this.state = {
      isOpen: false,
      isShow: false
    }
    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    if (!this.state.isShow) {
      this.setState({
        isOpen: !this.state.isOpen
      }, () => setTimeout(() => this.setState({
        isShow: !this.state.isShow
      }), 100))
    } else {
      this.setState({
        isShow: !this.state.isShow
      }, () => setTimeout(() => this.setState({
        isOpen: !this.state.isOpen
      }), 1000))
    }
  }

  render () {
    return (
      <header className="header">
        <div id="header-wrapper" className={`${this.state.isOpen ? 'open' : ''} ${this.state.isShow ? 'show' : ''}` }>
          {!this.props.isTop && (
            <span>
              <Link to="/" className="logo-link">
                <span className="logo-mark">
                  <img src={symbol} alt="Babels" />
                </span>
                <span className="logo-type">
                  <img src={logo} alt="Babels" />
                </span>
              </Link>
              <LngSwitcher />
            </span>
          )}
          <img src={humberger} alt="Menu" className="humberger" onClick={this.toggle} />
          <Menu current={this.props.current} />
        </div>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.js